import { Component, Input, OnInit } from '@angular/core';
import { DescriptionParserService } from 'app/core/services/parse-description.service';
import { Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'app-item-only-description',
    templateUrl: './item-only-description.component.html',
    styleUrls: ['./item-only-description.component.scss'],
    standalone: false
})
export class ItemOnlyDescriptionComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Listado de productos
   */
  @Input() section: SectionMenu = {} as SectionMenu;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  constructor(
    private menuService: MenuService,
    public descriptionParser: DescriptionParserService
  ) { }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }
}
